import axios from 'axios';
import React, { useEffect } from 'react';

function JsonToTable({url}) {
  const [data, setData] = React.useState(null);
  useEffect(() => {
    axios
      .get(url)
      .then((response) => response.data)
      .then((json) => {
        setData(json.fields);
      })
      .catch((error) => {
        console.log('Error => ', error);
      });
  }, []);

  function getHeadings(data) {
    return Object.keys(data[0]).map((key, i) => {
      return <th key={i}>{key}</th>;
    });
  }

  function getRows(data) {
    return data.map((obj, i) => {
      return <tr key={i}>{getCells(obj)}</tr>;
    });
  }

  function getCells(obj) {
    return Object.values(obj).map((value, i) => {
      if (typeof value === 'object') {
        return (
          <td key={i}>{`${Object.keys(value)} : ${Object.values(value)}`}</td>
        );
      } else {
        return <td key={i}>{value}</td>;
      }
    });
  }

  return (
    <>
      <p className="pt-4 pb-4 subtitle subtitle--black">
        <b>{`${data ? 'Diccionario de datos vista previa' : ''} `}</b>
      </p>
      <div className="table-responsive">
        <table className="table">
          <thead className='text-center'>{data ? getHeadings(data) : ''}</thead>
          <tbody>{data ? getRows(data) : ''}</tbody>
        </table>
      </div>
    </>
  );
}

export { JsonToTable };
